import { ENTITY, UserActions } from '@/enums';
import { DBConfig } from './dbConfig';

export interface ScopeActionArray {
  action: UserActions;
  metadata?: any;
}

export enum ScopeEffectEnum {
  ALLOW = 'ALLOW',
  DENY = 'DENY',
}

export interface Scope {
  id: number;
  action: UserActions;
  roleId: number;
  name: string;
  entity: ENTITY;
  metadata: any;
  description: string;
  effect: ScopeEffectEnum;
}

export interface TwoFactorAuthentication {
  isEnableSMSSetting: boolean;
  accessToken: string;
}

export interface AuthUserPoolInfo {
  subdomain?: string | null;
  tenantId?: string | null;
  userPoolId?: string | null;
  clientId: string;
  region?: string | null;
  country?: string | null;
  orgType?: string;
  supportedLanguages?: string[];
  dbConfig?: DBConfig;
}
